import { FaEnvelope, FaPhoneAlt, FaRegUser } from 'react-icons/fa';
import { IconInput } from 'components/VegasConference';

const PersonFields = ({ person, index, updatePerson, showError }) => {
  const fields = [
    { key: 'name', label: 'Full Name', icon: FaRegUser },
    { key: 'email', label: 'Email', icon: FaEnvelope, type: 'email' },
    { key: 'phone', label: 'Phone', icon: FaPhoneAlt, type: 'tel' }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {fields.map((f) => (
        <IconInput
          key={`${index}-${f.key}`}
          icon={f.icon}
          label={f.label}
          type={f.type}
          required
          value={person[f.key]}
          hasError={showError && !person[f.key]}
          onChange={(value) => updatePerson(index, f.key, value)}
        />
      ))}
    </div>
  );
};

export default PersonFields;
